import { useState } from "react";
import { Plus, Save, Trash2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

const TeamRow = ({ readOnly, team, onSave, onDelete }) => {
  const [f, setF] = useState({ name: team.name, specialty: team.specialty, members: team.members.join(", ") });
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const submit = () => onSave({ name: f.name, specialty: f.specialty, members: f.members.split(",").map((m) => m.trim()).filter(Boolean) }, team.id);
  return (
    <div data-testid={`team-editor-row-${team.id}`} className="grid grid-cols-1 gap-2 border-b border-[color:var(--border)] py-3 last:border-0 sm:grid-cols-[1fr_1fr_2fr_auto]">
      <Input disabled={readOnly} data-testid={`team-name-input-${team.id}`} value={f.name} onChange={set("name")} placeholder="Team name" />
      <Input disabled={readOnly} data-testid={`team-specialty-input-${team.id}`} value={f.specialty} onChange={set("specialty")} placeholder="Specialty" />
      <Input disabled={readOnly} data-testid={`team-members-input-${team.id}`} value={f.members} onChange={set("members")} placeholder="Members, comma separated" />
      {!readOnly && <div className="flex gap-1">
        <Button size="icon" variant="ghost" data-testid={`team-save-${team.id}`} onClick={submit}><Save className="h-4 w-4" /></Button>
        <Button size="icon" variant="ghost" data-testid={`team-delete-${team.id}`} onClick={() => onDelete(team.id)} className="text-red-400"><Trash2 className="h-4 w-4" /></Button>
      </div>}
    </div>
  );
};

export const TeamsEditor = ({ readOnly, teams, onSave, onDelete }) => (
  <div className="panel p-5">
    <div className="mb-2 flex items-center justify-between">
      <h3 className="font-display text-xl font-bold">Teams & Members</h3>
      {!readOnly && <Button data-testid="matrix-add-team-button" variant="outline" size="sm" onClick={() => onSave({ name: `Team ${teams.length + 1}`, specialty: "", members: [] })}><Plus className="mr-1 h-4 w-4" />Add Team</Button>}
    </div>
    {teams.map((t) => <TeamRow readOnly={readOnly} key={`${t.id}-${t.name}-${t.members.join()}`} team={t} onSave={onSave} onDelete={onDelete} />)}
  </div>
);
